import Vue from 'vue';
//enable devtools before everything else
// Vue.config.devtools = true;

import store from './store';
import { DatePicker } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

//axios needs a polyfill for Promise to work on IE
import 'es6-promise/auto';

import axios from 'axios';
window.axios = require('axios');

import { cloneDeep, unescape } from 'lodash';

Vue.use(DatePicker);

import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';

// configure language
locale.use(lang);

Vue.component('base-state-init', require('./components/BaseStateInit').default);
Vue.component('booking-mask', require('./components/BookingMask').default);
Vue.component('slider-wrapper', require('./components/SliderWrapper').default);
Vue.component('date-picker', require('./components/DatePickerElement').default);
Vue.component('send-request', require('./components/SendRequest').default);
Vue.component('two-sliders-no-pagination', require('./components/TwoSlidersNoPagination').default);
Vue.component('two-sliders-with-pagination', require('./components/TwoSlidersWithPagination').default);
Vue.component('two-sliders-rooms-with-pagination', require('./components/TwoSlidersRoomsWithPagination').default);
//enquiry form components
Vue.component('inquiry-form', require('./components/MultiForm/InquiryFormWrapper').default);
Vue.component('ContactUsForm', require('./components/MultiForm/ContactUsForm').default);
Vue.component('ConciergeForm', require('./components/MultiForm/ConciergeForm').default);
Vue.component('ChildcareForm', require('./components/MultiForm/ChildcareForm').default);
Vue.component('MiceSalesForm', require('./components/MultiForm/MiceSalesForm').default);
Vue.component('ReservationsForm', require('./components/MultiForm/ReservationsForm').default);
Vue.component('SportsAcademyForm', require('./components/MultiForm/SportsAcademyForm').default);
Vue.component('NewsletterForm', require('./components/MultiForm/NewsletterForm').default);
Vue.component('MiceRfpForm', require('./components/MultiForm/MiceRfpForm').default);
Vue.component('MediaEnquiryForm', require('./components/MultiForm/MediaEnquiryForm').default);
Vue.component('JobApplicationForm', require('./components/MultiForm/JobApplicationForm').default);
Vue.component('SpaCenterEnquiryForm', require('./components/MultiForm/SpaCenterEnquiryForm').default);
Vue.component('special-form', require('./components/MultiForm/SpecialForm').default);

export const eventBus = new Vue();


new Vue({
	store,
	el: '#app',
});
